import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import NPSSurveyForm from '../../components/NPS/NPSSurveyForm';
import useFetch from '../../helpers/useFetch';

const NPSSurveyNewPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const { accountId, domainId } = useParams();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const create = (npsSurvey) => {
    setLoading(true);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/nps-surveys`, {
      method: 'POST',
      body: JSON.stringify(npsSurvey),
    })
      .then(() => navigate(`/accounts/${accountId}/domains/${domainId}/nps`))
      .catch(setError)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Metadata title="NPS Surveys | New" />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/nps`}>NPS Surveys</Anchor>
        <Text>New</Text>
      </Breadcrumbs>

      <Grid>
        <Grid.Col span={12}>
          <NPSSurveyForm
            npsSurvey={{}}
            loading={loading}
            saveNpsSurvey={create}
            cancel={() => navigate(`/accounts/${accountId}/domains/${domainId}/nps`)}
          />
        </Grid.Col>
      </Grid>

      {error && (
        <div style={{ textAlign: 'right', marginTop: 8 }}>
          <ErrorMessage message={error.message} />
        </div>
      )}
    </>
  );
};

export default NPSSurveyNewPage;
